module.exports = __webpack_public_path__ + "img/IMG_1673_edited_cool_compressed_square.f1785f7d.jpg";